var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isPopinDisplayed,
          expression: "isPopinDisplayed",
        },
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: {
            callback: _vm.popin_confirmationReservationDisplayed_callback,
          },
          expression:
            "{ callback: popin_confirmationReservationDisplayed_callback }",
        },
      ],
      staticClass: "popin-modal centered",
      attrs: { id: "confirmation-reservation" },
    },
    [
      _c("div", { staticClass: "popin-container" }, [
        _c(
          "div",
          {
            staticClass: "popin-closure",
            on: { click: _vm.popin_confirmationReservationClosed },
          },
          [_c("div", { staticClass: "arrow" }, [_vm._v("X")])]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "popin-closure-responsive",
            on: { click: _vm.popin_confirmationReservationClosed },
          },
          [_c("div", { staticClass: "arrow" }, [_vm._v("X")])]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "popin" }, [
          _c("div", { staticClass: "popin-content" }, [
            _c("div", { staticClass: "popin-content-container" }, [
              _c("p", [_vm._v(" ")]),
              _vm._v(" "),
              _c(
                "p",
                [
                  _vm.reservation_status
                    ? [
                        _vm._v("Votre réservation pour "),
                        _c("span", [_vm._v(_vm._s(_vm.destination_label))]),
                        _vm._v(" a été confirmée !"),
                      ]
                    : [
                        _vm._v("Votre réservation pour "),
                        _c("span", [_vm._v(_vm._s(_vm.destination_label))]),
                        _vm._v(" n'a pas été validée."),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _c("p", [_vm._v(" ")]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }